import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppRoutes } from '@core/enums/routes.enum';
import { NgxPermissionsService } from 'ngx-permissions';

/**
 * Landing targets in preference order - the first one the user may open wins.
 * A hardcoded landing route locks out any role that cannot open it.
 */
const LANDING_TARGETS: { route: string; permission: string }[] = [
  { route: AppRoutes.application, permission: 'application.show' },
  { route: AppRoutes.apps, permission: 'paas_app.show' },
  { route: AppRoutes.flowCreator, permission: 'flow.show' },
  { route: AppRoutes.chat, permission: 'llm.show' },
  { route: AppRoutes.token, permission: 'token.show' },
  { route: AppRoutes.secret, permission: 'secret.show' },
  { route: AppRoutes.statistic, permission: 'flow_metric.show' },
  { route: AppRoutes.proxies, permission: 'http_proxy.show' },
  { route: AppRoutes.oAuthClient, permission: 'oauth_client.show' },
  { route: AppRoutes.globals, permission: 'global.show' },
];

/** Reachable without any permission, so it is always a safe last resort. */
const FALLBACK_URL = `/${AppRoutes.user}/${AppRoutes.profile}`;

@Component({
  selector: 'app-landing',
  template: '',
})
export class LandingComponent {
  constructor() {
    const permissions = inject(NgxPermissionsService).getPermissions();
    const target = LANDING_TARGETS.find(({ permission }) => permission in permissions);

    void inject(Router).navigateByUrl(target ? `/${target.route}` : FALLBACK_URL, { replaceUrl: true });
  }
}
